import { BaseSerializer } from '../base.serializer'
import { OnlineInterviewerSheduleShift } from 'models'

export class OnlineInterviwerScheduleShiftSerializer extends BaseSerializer<OnlineInterviewerSheduleShift> {
  static SERIALIZABLE_ATTRIBUTES = ["id", "from", "to", "capacity", "centerIds", "programIds", "types", "state"]
  static SERIALIZERS = {}
  static SERIALIZE_RENAME_KEYS = {}

  static DESERIALIZERS = {}
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): OnlineInterviewerSheduleShift {
    return new OnlineInterviewerSheduleShift(attributes)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/online-interviewer-schedule/online-interviewer-schedule-shift.serializer.ts